/* jshint -W024 */
import Roles from '@/domain/rolesEnum';
import i18n from '@/ui/i18n';

const BackOfficeRoutes = [
  {
    path: '/transacciones',
    name: 'transaction-approvals',
    parentName: 'primary-administration',
    meta: {
      title: i18n.t('backOffice.transactions'), // Transacciones
      iconName: 'file-invoice-dollar'
    },
    component: () => import('@/ui/views/internal/transaction-approval/TransactionsValidation.vue')
  },
  {
    path: '/remesar',
    name: 'consignments',
    parentName: 'consignments',
    meta: {
      roles: [Roles.BACKOFFICE_TREASURER, Roles.BACKOFFICE_FINANCE],
      title: i18n.t('backOffice.consignments'), // Remesas
      iconName: 'hand-holding-usd'
    },
    component: () => import('@/ui/views/internal/consignments/Consignments.vue')
  },
  {
    path: '/contabilidad',
    parentName: 'consignments',
    name: 'accounting',
    meta: {
      title: i18n.t('backOffice.accounting'), // Contabilidad
      iconName: 'balance-scale'
    },
    component: () => import('@/ui/views/internal/accounting/Accounting.vue')
  },
  {
    path: '/tesoreria',
    parentName: 'consignments',
    name: 'treasury',
    meta: {
      roles: [Roles.BACKOFFICE_TREASURER],
      title: i18n.t('backOffice.treasury'),
      iconName: 'bank'
    },
    component: () => import('@/ui/views/internal/cash-flow/CashFlows.vue')
  },
  {
    path: '/portability-support',
    name: 'portability-support',
    parentName: 'primary-administration',
    meta: {
      roles: [Roles.BACKOFFICE_FINANCE],
      title: i18n.t('backOffice.portability'), // Portabilidad
      iconName: 'random'
    },
    component: () => import('@/ui/views/internal/support/PortabilitySupport.vue')
  },
  {
    path: '/cobranza',
    name: 'collection',
    parentName: 'primary-administration',
    meta: {
      title: i18n.t('backOffice.collection'), // Cobranza
      iconName: 'file-invoice-dollar'
    },
    component: () => import('@/ui/views/internal/collection/Collection.vue')
  },
  {
    path: '/cobranza/:clientId',
    name: 'client-debt',
    redirect: { name: 'collect-debt' },
    meta: {
      ignore: true // para que no se agregue el boton en el menu de la izquierda
    },
    component: () => import('@/ui/views/internal/collection/CollectClientDebt.vue'),
    children: [
      {
        path: 'collect-debt',
        name: 'collect-debt',
        meta: {
          auth: true
        },
        component: () => import('@/ui/views/internal/pay-here/Select.vue')
      }
    ]
  },
  {
    path: '/trading',
    name: 'trading',
    parentName: 'consignments',
    meta: {
      title: i18n.t('backOffice.trading'), // Trading
      iconName: 'exchange-alt'
    },
    component: () => import('@/ui/views/internal/trading/Trading.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    parentName: 'none',
    meta: { title: i18n.t('backOffice.configuration'), iconName: 'sliders-h' }, // Configuración
    component: () => import('@/ui/views/internal/settings/Settings.vue')
  },
  {
    path: '/settings/features-toggles',
    name: 'features-toggles',
    meta: { ignore: true },
    component: () => import('@/ui/views/internal/settings/FeaturesToggles.vue')
  },
  {
    path: '/settings/settings-operations',
    name: 'settings-operations',
    meta: { ignore: true },
    component: () => import('@/ui/views/internal/settings/Operations.vue')
  },
  {
    path: '/amortization-schedule',
    name: 'amortization-schedule',
    parentName: 'sales',
    meta: {
      auth: true,
      roles: [Roles.BACKOFFICE],
      title: i18n.t('backOffice.developmentTable'), // Tabla de Desarrollo
      iconName: 'table'
    },
    component: () => import('@/ui/views/internal/AmortizationSchedule.vue')
  },
  {
    path: '/comercial',
    name: 'leads',
    parentName: 'sales',
    meta: { title: 'Gestor Comercial', iconName: 'user-friends' },
    component: () => import('@/ui/views/internal/commercial-manager/CommercialManager.vue')
  },
  {
    path: '/evaluations',
    name: 'evaluations',
    parentName: 'sales',
    meta: { title: i18n.t('backOffice.evaluations'), iconName: 'list-check' },
    component: () => import('@/ui/views/internal/evaluation/Evaluations.vue')
  },
  {
    path: '/risk-evaluation',
    name: 'risk-evaluation',
    parentName: 'sales',
    meta: { title: i18n.t('backOffice.riskEvaluation'), iconName: 'filter-circle-xmark' },
    component: () => import('@/ui/views/internal/risk-evaluation/RiskEvaluation.vue')
  },
  {
    path: '/risk-evaluation/:evaluationId',
    name: 'evaluation',
    parentName: 'sales',
    meta: { ignore: true },
    component: () => import('@/ui/views/internal/risk-evaluation/Evaluate.vue')
  },
  {
    path: '/evaluations/:evaluationId',
    name: 'evaluation-detail',
    meta: { ignore: true },
    component: () => import('@/ui/views/internal/evaluation/EvaluationDetail.vue')
  },
  {
    path: '/evaluations/:evaluationId/summary/:evaluationType',
    name: 'evaluation-summary',
    meta: { ignore: true },
    component: () => import('@/ui/views/internal/evaluation/EvaluationSummary.vue')
  },
  {
    path: '/evaluations/evaluate/:evaluationId',
    name: 'evaluation-process',
    meta: { ignore: true },
    component: () => import('@/ui/views/internal/evaluation/EvaluationProcess.vue')
  },
  {
    path: '/broker/:brokerId',
    name: 'broker-details',
    meta: { ignore: true },
    component: () => import('@/ui/views/internal/brokers/BrokerDetails.vue')
  },
  {
    path: '/leads/:prospectId',
    name: 'leads-details',
    meta: { ignore: true },
    component: () => import('@/ui/views/internal/leads/LeadsDetails.vue')
  },
  {
    path: '/collectings',
    parentName: 'primary-administration',
    name: 'collectings',
    meta: {
      title: i18n.t('backOffice.collectings'),
      iconName: 'coins'
    },
    component: () => import('@/ui/views/internal/collectings/Collectings.vue')
  },
  {
    path: '/operations',
    name: 'operations',
    parentName: 'primary-administration',
    meta: {
      title: i18n.t('backOffice.operations'),
      iconName: 'table'
    },
    component: () => import('@/ui/views/internal/operations/Operations.vue')
  },
  {
    path: '/operations/:operationId',
    name: 'operation-management',
    meta: {
      ignore: true
    },
    component: () => import('@/ui/views/internal/operations/OperationManagement.vue')
  }
];

export default BackOfficeRoutes;
